var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "cardHeader" }, [
            _c("b", [_vm._v("Dados do Cálculo:")])
          ]),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Munícipio:",
                      content: _vm.dadosVtn.municipio.nome,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor de referência por " + _vm.tipoArea + ":",
                      content:
                        "R$ " + _vm.formatarValor(_vm.dadosVtn.valorReferencia),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Taxas diversas:",
                      content:
                        "R$ " +
                        _vm.formatarValor(
                          _vm.dadosVtn.taxaDiversa
                            ? _vm.dadosVtn.valorVtn * 0.1
                            : "0,00"
                        ),
                      contentAlignRight: false
                    }
                  }),
                  _vm.dadosVtn.taxaDiversa
                    ? _c("p", { staticClass: "aviso-taxa" }, [
                        _vm._v(
                          "Foi acrescida uma taxa de 10% sobre o valor total da VTN."
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Área requerida:",
                      content:
                        _vm.formatarValor(_vm.dadosVtn.areaRequerida) +
                        " " +
                        _vm.tipoArea,
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: _vm.isReurbIndividual ? "Valor total:" : "VTN:",
                      content: "R$ " + _vm.formatarValor(_vm.dadosVtn.valorVtn),
                      contentAlignRight: false
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: _vm.isReurbIndividual
                        ? "Valor total a ser pago:"
                        : "Valor de referência do imóvel:",
                      content:
                        "R$ " +
                        _vm.formatarValor(_vm.dadosVtn.valorReferenciaImovel),
                      contentAlignRight: false
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b20f56a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b20f56a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/ConfirmarDadosMa.vue
// module id = null
// module chunks = 